<div class="contact-email-section">
  <p class="contact-email-section__lead">
    A separate email address for receipts, alerts, and important updates. Useful when
    your sign-in account doesn’t have a mailbox.
  </p>

  @if ((contactEmailVerified$ | async)) {
    <div class="contact-email-section__row">
      <span class="contact-email-section__badge contact-email-section__badge--verified">Verified</span>
      <span class="contact-email-section__email">{{ contactEmail$ | async }}</span>
      @if (!showReplace) {
        <button type="button"
          class="contact-email-section__btn contact-email-section__change"
          (click)="onChangeAfterVerified()">
          Change
        </button>
      }
    </div>
    @if (showReplace) {
      <div class="contact-email-section__form">
        <label class="contact-email-section__label">Replace with a different email</label>
        <input
          type="email"
          class="contact-email-section__input"
          [(ngModel)]="email"
          name="newContactEmail"
          placeholder="you@example.com"
          [disabled]="status === 'sending'"
          />
        @if (message) {
          <p class="contact-email-section__message"
          [class.contact-email-section__message--error]="status === 'error'">{{ message }}</p>
        }
        <div class="contact-email-section__actions">
          <button type="button"
            class="contact-email-section__btn contact-email-section__btn--primary"
            [disabled]="status === 'sending' || cooldownSec > 0 || !email"
            (click)="onSend()">
            @if (status !== 'sending') {
              Send activation link
            } @else {
              Sending…
            }
          </button>
          <button type="button"
            class="contact-email-section__btn contact-email-section__btn--ghost"
            [disabled]="status === 'sending'"
            (click)="onCancelReplace()">
            Cancel
          </button>
        </div>
      </div>
    }
  } @else {
    @if ((contactEmailPending$ | async); as pendingEmail) {
      <div class="contact-email-section__row">
        <span class="contact-email-section__badge contact-email-section__badge--pending">Awaiting confirmation</span>
        <span class="contact-email-section__email">{{ pendingEmail }}</span>
      </div>
      <p class="contact-email-section__lead">
        We sent an activation link to <strong>{{ pendingEmail }}</strong>. Click the link
        to finish. The link expires in 24 hours.
      </p>
      @if (message) {
        <p class="contact-email-section__message"
        [class.contact-email-section__message--error]="status === 'error'">{{ message }}</p>
      }
      <div class="contact-email-section__actions">
        <button type="button"
          class="contact-email-section__btn contact-email-section__btn--primary"
          [disabled]="status === 'sending'"
          (click)="onRefresh()">
          I’ve clicked the link
        </button>
        <button type="button"
          class="contact-email-section__btn"
          [disabled]="status === 'sending' || cooldownSec > 0"
          (click)="onResend()">
          @if (cooldownSec > 0) {
            Resend in {{ cooldownSec }}s
          } @else {
            Resend email
          }
        </button>
        <button type="button"
          class="contact-email-section__btn contact-email-section__btn--ghost"
          [disabled]="status === 'sending'"
          (click)="onClearPending()">
          Use a different email
        </button>
      </div>
    } @else {
      <div class="contact-email-section__form">
        <label class="contact-email-section__label">Contact email</label>
        <input
          type="email"
          class="contact-email-section__input"
          [(ngModel)]="email"
          name="contactEmail"
          placeholder="you@example.com"
          [disabled]="status === 'sending'"
          />
        @if (message) {
          <p class="contact-email-section__message"
          [class.contact-email-section__message--error]="status === 'error'">{{ message }}</p>
        }
        <div class="contact-email-section__actions">
          <button type="button"
            class="contact-email-section__btn contact-email-section__btn--primary"
            [disabled]="status === 'sending' || cooldownSec > 0 || !email"
            (click)="onSend()">
            @if (status !== 'sending') {
              Send activation link
            } @else {
              Sending…
            }
          </button>
        </div>
      </div>
    }
  }

</div>
